// Updated Help.jsx (no logic changes, only styling relies on CSS)
import { useMemo, useState } from "react";
import AppShell from "../layout/AppShell";
//import helpPdf from "../assets/help/TeamBridge_Help_Guide.pdf";
import helpPdf from "../assets/help/TeamBridge Onboarding User Guide v0.1.pdf";
//import helpPpt from "../assets/help/TeamBridge_Help_Guide.pptx";
import helpPpt from "../assets/help/TEAM BRIDGE Office hours 3.20.pptx";

import "./Help.css";

const HELP_TABS = [
    {
        key: "npw-onboarding",
        label: "NPW Fresh Onboarding",
        section: "Vendor / Nominator",
        audience: "NPW Vendor / Nominator",
        title: "NPW fresh onboarding",
        summary:
            "Use this flow for new non-payroll worker onboarding requests. Complete worker, vendor, contract, and identity details accurately before submission.",
        highlight: [
            "Use SSN for US-based workers and Secure ID for international workers.",
            "End Date must be the contract end date.",
            "Billable must be set to 'Yes'.",
            "If ATTUID is required, validation must pass before continuing.",
        ],
        steps: [
            "Log into Team Bridge at https://teambridge.directv.com/.",
            "Click New Onboarding.",
            "Provide all required worker, assignment, and vendor details.",
            "Add SSN for US-based workers or Secure ID for international workers.",
            "Set End Date to the contract end date.",
            "Set Billable to 'Yes'.",
            "Make sure Vendor details are populated.",
            "Click Continue after all required information is entered.",
            "On the next page, click Validate if ATTUID is required. If ATTUID is not required, you can submit the request into the approval process.",
            "If ATTUID Required = Yes, click Validate and make sure there are no AT&T validation errors for the data provided.",
            "If validation is successful, click Continue and submit the request.",
            "If any errors are returned, update the form accordingly and then submit the request.",
        ],
        tips: [
            "Review identity data carefully before validating with AT&T.",
            "Do not proceed with ATTUID-required requests until validation is clean.",
            "Keep contract dates aligned with the actual engagement period.",
        ],
    },
    {
        key: "employee-onboarding",
        label: "DIRECTV Employee Onboarding",
        section: "Employee",
        audience: "Employee Self / Employee Manager",
        title: "DIRECTV employee onboarding",
        summary:
            "Use these onboarding instructions for DIRECTV employee self-onboarding and manager resource onboarding.",
        highlight: [
            "End Date must be 3 years from the date of submission.",
            "Billable must be set to 'No'.",
            "AT&T validation must be completed on the final page before submission.",
        ],
        subSections: [
            {
                title: "Self onboarding",
                steps: [
                    "Log into Team Bridge at https://teambridge.directv.com/.",
                    "Select the Self radio button and click Onboard.",
                    "Provide the required details.",
                    "Set End Date to 3 years from the date of submission.",
                    "Set Billable to 'No'.",
                    "Select Continue.",
                    "Click Validate on the final page to review the data with AT&T.",
                    "If there are no validation errors, submit the request.",
                ],
            },
            {
                title: "Manager resource onboarding",
                steps: [
                    "Log into Team Bridge at https://teambridge.directv.com/.",
                    "Select Others, then select the Employee radio button, and click Onboard.",
                    "Provide the required details.",
                    "Set End Date to 3 years from the date of submission.",
                    "Set Billable to 'No'.",
                    "Select Continue.",
                    "Click Validate on the final page to review the data with AT&T.",
                    "If there are no validation errors, submit the request.",
                ],
            },
        ],
        tips: [
            "Employee onboarding requests follow the employee-specific date and billing rules.",
            "Validate on the final page before submitting to avoid downstream rework.",
        ],
    },
    {
        key: "modify",
        label: "Modify Requests",
        section: "Employee / Vendor",
        audience: "Employee Self / NPW Vendor",
        title: "modify existing worker details",
        summary:
            "Use the modify flows below when worker profile details need to be updated after onboarding.",
        highlight: [
            "Employee self-modify uses a 3-year end date and Billable = 'No'.",
            "NPW vendor modify uses contract end date and Billable = 'Yes'.",
            "For NPW vendor modify, ATT ID Required must be turned on.",
        ],
        subSections: [
            {
                title: "DIRECTV Employee - Self Modify",
                steps: [
                    "Employee logs into Team Bridge at https://teambridge.directv.com/.",
                    "Select Onboard.",
                    "Complete all required fields such as City and State.",
                    "Select Edit on SSN and add SSN.",
                    "Set End Date to 3 years from the date of submission.",
                    "Set Billable to 'No'.",
                    "Select Submit.",
                    "The request will then flow to the next level approver.",
                ],
            },
            {
                title: "NPW Vendor Modify",
                steps: [
                    "Log into Team Bridge at https://teambridge.directv.com/.",
                    "Search for the worker in the search bar at the top of the screen.",
                    "Click the worker's name.",
                    "Select the Edit button on the top right of the screen.",
                    "Complete all required fields such as City and State.",
                    "Ensure the ATT ID Required button is turned on.",
                    "Select Edit on SSN and add SSN for US-based workers or Secure ID for international workers.",
                    "Set End Date to the contract end date.",
                    "Set Billable to 'Yes'.",
                    "Select Continue.",
                    "Select Submit.",
                ],
            },
        ],
        tips: [
            "Use the worker-type-specific date and billing rule every time.",
            "Verify identity information before saving updates.",
        ],
    },
    {
        key: "offboarding",
        label: "Offboarding",
        section: "Vendor / Employee",
        audience: "NPW Vendor / Employee Self / Employee Manager",
        title: "worker offboarding",
        summary:
            "Use the correct offboarding path based on who is initiating the request and whether the worker is vendor-based or employee-based.",
        highlight: [
            "Choose the appropriate offboarding type before submission.",
            "Always provide the required offboarding date.",
            "Use the correct role entry point: Vendor, Self, or Others.",
        ],
        subSections: [
            {
                title: "NPW Vendor Offboarding",
                steps: [
                    "Log into Team Bridge at https://teambridge.directv.com/.",
                    "Search for the worker in the Manage Requests page.",
                    "Select the record and click Offboarding.",
                    "Select the offboarding type: DTVID/ATTUID or ATTUID alone.",
                    "Provide the required dates and submit the request.",
                ],
            },
            {
                title: "DIRECTV Employee - Self Offboarding",
                steps: [
                    "Log into Team Bridge at https://teambridge.directv.com/.",
                    "Select Self and click Offboarding.",
                    "Choose the date and submit.",
                ],
            },
            {
                title: "DIRECTV Employee Manager - Resource Offboarding",
                steps: [
                    "Log into Team Bridge at https://teambridge.directv.com/.",
                    "Select Others.",
                    "Choose the Resource radio button and click Offboarding.",
                    "Choose the date and submit.",
                ],
            },
        ],
        tips: [
            "Confirm the correct worker record before initiating offboarding.",
            "Use the correct offboarding option to match the identifiers being removed.",
        ],
    },
    {
        key: "sponsor",
        label: "Sponsor Approval",
        section: "Approval",
        audience: "Employee Sponsor",
        title: "employee sponsor approval",
        summary:
            "Sponsors review submitted requests, confirm ATTUID requirement status, and route the request forward through approval.",
        highlight: [
            "Review the submitted record before approval.",
            "Comments should be provided as part of the action.",
            "Approve with ATT ID = Yes when required, or No when not required.",
        ],
        steps: [
            "Select the record for approval.",
            "Provide comments.",
            "Click 'Yes' for ATT ID if ATTUID is required, or click 'No' if ATTUID is not required.",
            "Click Approve and submit.",
        ],
        tips: [
            "Review the business need and completeness before approving.",
            "Make sure the ATT ID selection matches the request requirement.",
        ],
    },
    {
        key: "cp",
        label: "CP Delegate Approval",
        section: "Approval",
        audience: "CP Delegate",
        title: "cp delegate approval",
        summary:
            "CP delegates complete the final approval activity for requests that route to the CP approval stage.",
        highlight: [
            "Review the submitted request details before actioning it.",
            "Comments should be entered with the approval action.",
        ],
        steps: [
            "Select the record for approval.",
            "Provide comments.",
            "Click Approve and submit.",
        ],
        tips: [
            "Validate the request context before approval.",
            "Use comments to document any important approval notes.",
        ],
    },

    {
        key: "att-status-check",
        label: "AT&T Status Check",
        section: "AT&T Support",
        audience: "Vendor / Sponsor / Operations",
        title: "AT&T status check",
        summary:
            "Use this flow after CP Delegate approval to confirm the AT&T submission status using Agent ID, Tracking ID, or DTVID.",
        highlight: [
            "Use Agent ID and Tracking ID from the vendor or sponsor email when available.",
            "DTVID can be used when Agent ID or Tracking ID is not available.",
            "DTVID search pulls the latest submitted record status sent to AT&T.",
        ],
        steps: [
            "After CP Delegate approval, check the email the vendor or sponsor received for the Agent ID / Tracking ID created after submitting to AT&T.",
            "Take the Agent ID and Tracking ID from that email.",
            "Go to the AT&T Status Check tab.",
            "Search for the record using Agent ID and/or Tracking ID, then review the returned status of the person.",
            "If you do not have the Tracking ID or Agent ID, search with DTVID. TeamBridge will pull the latest submitted record status sent to AT&T.",
        ],
        tips: [
            "Use Agent ID or Tracking ID first when the email contains them.",
            "Use DTVID as the fallback when Agent ID and Tracking ID are not available.",
            "Review the status response and any returned error messages before taking the next action.",
        ],
    },
    {
        key: "reactivation",
        label: "ATTUID Reactivate",
        section: "AT&T Support",
        audience: "Vendor / Operations",
        title: "ATTUID reactivation",
        summary:
            "Use this flow to reactivate an existing ATTUID for a worker when the record is eligible for reactivation.",
        highlight: [
            "Search and open the correct worker record before starting.",
            "Validation with AT&T must succeed before submission.",
            "Provide Security ID or SSN if it is not already available.",
        ],
        steps: [
            "Log into Team Bridge at https://teambridge.directv.com/.",
            "Search for the worker in the search bar at the top of the screen.",
            "Click the worker's name.",
            "Select the Reactivate ATTUID button on the top right of the screen.",
            "Wait for the details to load.",
            "Provide Security ID or SSN if it is not already there.",
            "Click Validate to validate the data with AT&T.",
            "If validation is successful, click Submit. The request will then go through the approvals process.",
        ],
        tips: [
            "Do not submit until validation returns successfully.",
            "Use the worker's latest identity data when missing values must be entered.",
        ],
    },
    {
        key: "password-reset",
        label: "AT&T Password Reset",
        section: "AT&T Support",
        audience: "All Users",
        title: "ATTUID password reset resources",
        summary:
            "Use the links below for ATTUID account status checks, activation or reactivation, and VPN/MFA access requests.",
        highlight: [
            "Use the appropriate support link based on the issue type.",
            "Account status, activation/reactivation, and access requests are handled through separate tools.",
        ],
        links: [
            {
                label: "User Account Status Tool",
                href: "https://sresets.it.att.com/AccountStatus/",
                helper: "Use this tool for ATTUID account status checks.",
            },
            {
                label: "Activate / Reactivate Domain Accounts",
                href: "https://saorder.sbc.com/",
                helper: "Use this portal to activate or reactivate domain accounts.",
            },
            {
                label: "Access Portal",
                href: "https://accessportal.att.com/portaluser/#/home",
                helper: "Use this portal to request VPN or MFA access for AT&T.",
            },
        ],
        tips: [
            "Use password reset resources only for password or access-related issues.",
            "Use reactivation when the account issue is related to account status rather than password only.",
        ],
    },
];

function StepList({ steps }) {
    return (
        <ol className="tb-help-step-list">
            {steps.map((step) => (
                <li key={step}>{step}</li>
            ))}
        </ol>
    );
}

export default function Help() {
    const [activeTab, setActiveTab] = useState(HELP_TABS[0].key);

    const currentTab = useMemo(
        () => HELP_TABS.find((tab) => tab.key === activeTab) || HELP_TABS[0],
        [activeTab]
    );

    return (
        <AppShell activeKey="/help">
            <div className="tb-help-page">
                <section className="tb-help-hero">
                    <div className="tb-help-hero-copy">
                        <div className="tb-help-kicker">TeamBridge Operational Guide</div>
                        <h1>Help Center</h1>
                        <p>
                            Central guidance for onboarding, modify, offboarding, approval,
                            reactivation, and AT&amp;T support processes. Content is organized by
                            role so users can quickly locate the exact process they need with a
                            cleaner, business-focused navigation experience.
                        </p>
                        {/*
                        <div className="tb-help-hero-meta">
                            <div className="tb-help-hero-meta-card">
                                <span className="tb-help-meta-label">Coverage</span>
                                <strong>8 Process Areas</strong>
                            </div>
                            <div className="tb-help-hero-meta-card">
                                <span className="tb-help-meta-label">Audience</span>
                                <strong>Vendor, Employee, Sponsor, CP Delegate</strong>
                            </div>
                            <div className="tb-help-hero-meta-card">
                                <span className="tb-help-meta-label">Usage</span>
                                <strong>Final step-by-step reference</strong>
                            </div>
                        </div>
                        */}
                    </div>

                    <aside className="tb-help-download-compact" aria-label="Help guide downloads">
                        <div className="tb-help-download-compact-header">
                            <div className="tb-help-download-panel-title">Quick resources</div>
                            <div className="tb-help-download-panel-subtitle">
                                Download the latest guide pack.
                            </div>
                        </div>

                        <div className="tb-help-download-link-list">
                            <a
                                href={helpPdf}
                                download="TeamBridge_Help_Guide.pdf"
                                className="tb-help-mini-link primary"
                            >
                                <span className="tb-help-mini-link-icon" aria-hidden="true">↓</span>
                                <span className="tb-help-mini-link-copy">
                                    <strong>PDF Guide</strong>
                                    <small>Printable version</small>
                                </span>
                            </a>

                            <a
                                href={helpPpt}
                                download="TeamBridge_Help_Guide.pptx"
                                className="tb-help-mini-link"
                            >
                                <span className="tb-help-mini-link-icon" aria-hidden="true">↓</span>
                                <span className="tb-help-mini-link-copy">
                                    <strong>PPT Guide</strong>
                                    <small>Presentation version</small>
                                </span>
                            </a>
                        </div>
                    </aside>
                </section>

                <section className="tb-help-tabs-shell">
                    <div className="tb-help-tabs-header">
                        <div>
                            <div className="tb-help-tabs-eyebrow">Role-based navigation</div>
                            <h2>Process Library</h2>
                        </div>
                        <div className="tb-help-tabs-caption">
                            Choose a tab to see the exact business steps, role ownership, and key reminders for that process.
                        </div>
                    </div>

                    <div className="tb-help-toolbar" role="tablist" aria-label="Help process tabs">
                        {HELP_TABS.map((tab) => {
                            const active = tab.key === activeTab;
                            return (
                                <button
                                    key={tab.key}
                                    type="button"
                                    role="tab"
                                    aria-selected={active}
                                    className={`tb-help-tab-btn tb-help-tab-btn-compact ${active ? "active" : ""}`}
                                    onClick={() => setActiveTab(tab.key)}
                                >
                                    <span className="tb-help-tab-title">{tab.label}</span>
                                    <span className="tb-help-tab-subtitle">{tab.section}</span>
                                </button>
                            );
                        })}
                    </div>
                </section>

                <section className="tb-help-panel" role="tabpanel" aria-live="polite">
                    <div className="tb-help-panel-top">
                        <div>
                            <span className="tb-help-section-tag">{currentTab.section}</span>
                            <h2>{currentTab.title}</h2>
                        </div>

                        <div className="tb-help-panel-chips">
                            <span className="tb-help-chip">Audience: {currentTab.audience}</span>
                        </div>
                    </div>

                    <p className="tb-help-summary">{currentTab.summary}</p>

                    {/*
                    <div className="tb-help-overview-strip">
                        {currentTab.highlight?.map((item) => (
                            <div key={item} className="tb-help-overview-item">
                                <span>Key rule</span>
                                <strong>{item}</strong>
                            </div>
                        ))}
                    </div>
                    */}
                    {currentTab.steps ? (
                        <div className="tb-help-grid single">
                            <div className="tb-help-card primary">
                                <div className="tb-help-card-header">
                                    <h3>Step-by-step instructions</h3>
                                    <span>Execution flow</span>
                                </div>
                                <StepList steps={currentTab.steps} />
                            </div>

                            <div className="tb-help-card secondary">
                                <div className="tb-help-card-header">
                                    <h3>Important notes</h3>
                                    <span>Operational reminders</span>
                                </div>
                                <ul className="tb-help-bullet-list">
                                    {currentTab.tips?.map((item) => (
                                        <li key={item}>{item}</li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    ) : null}

                    {currentTab.subSections ? (
                        <div className="tb-help-subsection-stack">
                            {currentTab.subSections.map((section) => (
                                <div key={section.title} className="tb-help-subsection-card">
                                    <div className="tb-help-subsection-header">
                                        <h3>{section.title}</h3>
                                        <span>Role-specific flow</span>
                                    </div>
                                    <StepList steps={section.steps} />
                                </div>
                            ))}

                            <div className="tb-help-card secondary">
                                <div className="tb-help-card-header">
                                    <h3>Important notes</h3>
                                    <span>Operational reminders</span>
                                </div>
                                <ul className="tb-help-bullet-list">
                                    {currentTab.tips?.map((item) => (
                                        <li key={item}>{item}</li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    ) : null}

                    {currentTab.links ? (
                        <div className="tb-help-links-card">
                            <div className="tb-help-card-header">
                                <h3>Support links</h3>
                                <span>External resources</span>
                            </div>
                            <div className="tb-help-link-grid">
                                {currentTab.links.map((link) => (
                                    <a
                                        key={link.label}
                                        className="tb-help-resource-link"
                                        href={link.href}
                                        target={link.href.startsWith("http") ? "_blank" : undefined}
                                        rel={link.href.startsWith("http") ? "noreferrer" : undefined}
                                    >
                                        <strong>{link.label}</strong>
                                        <span>{link.helper}</span>
                                    </a>
                                ))}
                            </div>
                            <div className="tb-help-mini-note">
                                <strong>Important:</strong> For internal tools where a direct URL is not listed here,
                                use the enterprise link or bookmark already provided by your organization.
                            </div>
                        </div>
                    ) : null}
                </section>
            </div>
        </AppShell>
    );
}
